var mp = mp || {};

// Toogle Search
//-----------------------------------------------------------------
mp.toggleSearch = function() {
	var $form = $('#form-search');
    var $element = $('#form-search .submit_btn');

    if (!$element.length) {
        return;
    }
    
    $element.on('click', function(e) {
        e.preventDefault();
        
        $input = $form.find('.input');
        $val = $input.val();

        if ($val.length > 0) {
            $form.submit();
        } else {
            //$form.toggleClass("expand");
            $input.focus();
        }
    });
}


$(document).ready(function(){
    mp.toggleSearch();
});